const Ods = new function () {
    let main = null
    let labels = []
    let sections = []
    
    this.init = () => {
        main = document.querySelector('.sn-main__content')
        document.querySelectorAll('.sn-ods__item').forEach(label => labels.push(label))
        document.querySelectorAll('.sn-section').forEach(section => sections.push(section))
        document.querySelectorAll('.sn-page-head').forEach(pageHead => sections.push(pageHead))
        
        sections.forEach(section => {
            ScrollTrigger.create({
                trigger: section,
                start: 'top top+=25%',
                end: 'bottom top+=25%',
                onEnter: (e) => {
                    this.onSectionEnter(e.trigger)
                },
                onEnterBack: (e) => {
                    this.onSectionEnter(e.trigger)
                },
                scroller: '#sn-page',
                // markers: true,
            })
        })

        if (main) {
            ScrollTrigger.create({
                trigger: main,
                start: 'top top+=25%',
                end: 'bottom top+=25%',
                onLeave: this.clearLabels,
                onLeaveBack: this.clearLabels,
                scroller: '#sn-page',
            })
        }
    }

    this.onSectionEnter = (section) => {
        const odsList = section.classList;
        labels.forEach(label => {
            if (odsList.contains('ods-' + label.dataset.ods)) {
                label.classList.add('active')
            } else if (label.classList.contains('active')) {
                label.classList.remove('active')
            }
        })
    }

    this.clearLabels = () => {
        labels.forEach(label => label.classList.remove('active'))
    }
}

export default Ods